export default "__VITE_ASSET__BZnk5ZUS__"